import React from 'react';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { RouteComponentProps } from 'react-router';
import { IStore } from 'reducers/index';
import { fetchETS, fetchETSDetails, resetEtsDetails, sendCreateSalesOrderImport, fetchNftpBillable } from 'actions/ets';
import { resendLatestMessage } from 'actions/sap';
import { updateCharges, refreshAthenaRates, fetchPendingProcessMessages } from 'actions/costRevenue';
import { ErrorDialog } from 'components/error-dialog';
import { IETSDetail } from 'reducers/ets/models';
import API from 'constants/api';
import { IMaterialList } from 'reducers/materialMaster';
import { PageHeader } from 'components/page-header';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { calculateTotalOfField, calculateDivisionBreakdown, generateDistributionData, IDivisionBreakdown } from 'views/job-costing/utils/CostAndRevenueHelpers'; // calculateTotalOfField,
import { CostAndRevenue } from 'modules/cost-revenue/component/CostAndRevenue';
import ETSDetails from './ETSDetails';
import { DetailsTopBar } from './DetailsTopBar';
import {
    navLinksETS,
    voyagesCols,
    cblColsEts,
    equipmentColsEts,
    documentCols,
    customerInvoiceCols,
} from 'constants/tableConstants';
import { withRouter } from 'react-router-dom';
import { formatValueIfNullOrUndefined, formatDate, clearFormat, isFeatureEnabled } from 'utilities/util'; // clearFormat, 
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { HeaderWrapper } from 'components/cost-revenue/HeaderWrapper';
import InPageDialog from '../../../../components/page-dialog';
import { Partners } from 'modules/partners/Partners';
import { HistoryLog } from 'modules/history/HistoryLog';
import * as ValidationMessages from 'constants/validationMessages';
import { FinOpsStatus, chargeStatus, costAndRevErrorMessage } from 'views/job-costing/utils/models';
import { ConfirmModal } from 'components/confirm-modal';
import { shipmentCols } from 'views/job-costing/search/booking/models';
import { setFilter, applyFiltersAction } from 'actions/filters';
import QuickSearch from 'modules/quickSearch/QuickSearch';
import { CATEGORY } from 'constants/Levels';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { localCurrency } from 'constants/customs';
import { fetchCostAndRevenue } from 'actions/costRevenue';
import { IResponse } from 'reducers/bookings/models';
import { targetFunctionality } from 'constants/targetFunctionality';
import { ModalMain } from 'damco-components';
import { ATHENA } from 'constants/messages';
import CustomErrorBox from 'components/custom-error-box/custom-error-box';
import { isNftpRoeEnabled, calculateActualTotal } from 'utilities/nftp';
import { BatchProcessingWarning } from 'components/batch-processing-warning';
import { isBatchProcessingError } from 'utilities/batchProcessing';
import { IHistoryLogModel } from 'reducers/historyLog/models';
import { fetchHistoryLog } from 'actions/historyLog';

interface IParams {
    etsId: string;
}
interface IMapDispatchToProps {
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    fetchETS: (pageNumber: number, pageSize: number) => Promise<void>;
    fetchETSDetails: (documentId: string) => Promise<void>;
    applyFilters: () => void;
    updateCharges: (docId: string, docStage: number, rateAction: number, category: string) => Promise<void>;
    resendLatestMessage: (docId: string, finOpsStatus: string) => Promise<void>;
    resetEtsDetails: () => void;
    fetchCostAndRevenue: (type: number, valueId: any[], targetType: string) => Promise<void>;
    refreshAthenaRates: (refId: number, docId: number, docStage: number, rateAction: number) => Promise<void>;
    createSalesOrderImport: (refId: number, docStage: number, rateAction: number, category: string, userId: string) => Promise<any>;
    getPendingProcessMessage: (targetId: number, targetType: string) => void;
    fetchNftpBillable: (jobId: number) => Promise<void>;
    fetchHistoryLog: (shipmentId: string, shipmentType: string | number) => Promise<void>;
}
interface IMapStateToProps {
    etsDetails: IETSDetail;
    isLoading: boolean;
    isFetchDataError: boolean;
    isDataFetchErrorCostNRevenue: boolean;
    detailsPendingError: string,
    update: string,
    materialMasterList: IMaterialList[];
    invoicedResponse: any;
    submitInvoiceError: boolean;
    ets: any;
    resendResponse: string,
    resendLoading: boolean,
    resendError: string | string[],
    isResendError: boolean,
    featureToggles: IFeatureToggleModel[],
    costAndrevenueresponse: IResponse;
    nickname: any,
    cblId: number;
    pendingProcessingMessages: { [key: string]: any; };
    isNftpBillable: boolean | undefined;
    isNftpBillableLoading: boolean;
    response: IHistoryLogModel[];
}
interface IDocCharges extends RouteComponentProps<IParams>, IMapDispatchToProps, IMapStateToProps { }
interface IState {
    activeTab: number;
    disableTab: boolean;
    hasError: boolean;
    totalRevenue: string;
    totalCost: string;
    divisionBreakdown: IDivisionBreakdown;
    showDialog: boolean;
    wasSubmitted: boolean;
    confirmDialogVisible: boolean;
    confirmDialogCancelSOVisible: boolean;
    isSuccess: boolean;
    pendingError: string;
    status: string[] | null;
    results: any[];
    isActionHidden: boolean;
    confirmDialogUpdateVisible: boolean;
    showPendingProcessMessage: boolean;
    showPendingProcessMessageModal: boolean;
    isNftpRoeEnabled?: boolean;
    isNftpRoeEnabledLoading?: boolean;
    actualRevenue?: string;
    actualCost?: string;
    showEmptyReturnLocation?: boolean;
    showZeroPriceError?: boolean;
}
export class _ChargesETSDetails extends React.Component<IDocCharges, IState> {
    constructor(props: IDocCharges) {
        super(props);
        this.state = this.initialState();
    }
    public componentDidMount() {
        this.loadData();
    }
    public loadData = async () => {
        if (isFeatureEnabled(FEATURE_TOGGLES.FINOPS_NFTP_SALESORDER_REQ_IMPORT, this.props.featureToggles)) {
            await this.props.fetchNftpBillable(Number(this.props.match.params.etsId));
        }
        this.setState({ isNftpRoeEnabled: isNftpRoeEnabled(this.props.isNftpBillable ?? false, this.props.featureToggles) });
        this.setState({ isNftpRoeEnabledLoading: false});
        await this.props.fetchETSDetails(this.props.match.params.etsId);
        await this.props.fetchCostAndRevenue(5, [Number(this.props.match.params.etsId)], 'destination');
        this.getActualTotal();
        const { cblId, getPendingProcessMessage, featureToggles } = this.props;
        if (featureToggles && isFeatureEnabled(FEATURE_TOGGLES.SHOW_PENDING_PROCESSING_MESSAGES, this.props.featureToggles)) {
            getPendingProcessMessage(cblId, 'Import');
        }
    };
    public componentWillUnmount() {
        this.setState(this.initialState());
        this.props.resetEtsDetails();
    }
    public initialState = (): IState => {
        return {
            activeTab: 0,
            isSuccess: false,
            disableTab: false,
            showDialog: false,
            wasSubmitted: false,
            confirmDialogVisible: false,
            confirmDialogCancelSOVisible: false,
            totalRevenue: '0',
            totalCost: '0',
            divisionBreakdown: { rows: [], total: { division: 'Total', revenue: 0, cost: 0, profit: 0 } },
            pendingError: '',
            status: null,
            hasError: false,
            results: [],
            isActionHidden: false,
            confirmDialogUpdateVisible: false,
            showPendingProcessMessage: false,
            showPendingProcessMessageModal: false,
            isNftpRoeEnabled: false,
            isNftpRoeEnabledLoading: true,
            actualRevenue: '0',
            actualCost: '0',
            showEmptyReturnLocation: false,
            showZeroPriceError: false
        };
    };
    public async componentDidUpdate(props: any) {

        if (props.pendingProcessingMessages !== this.props.pendingProcessingMessages) {
            this.setState({ showPendingProcessMessage: true });
        }
        // Zero price validation
        if (this.props.costAndrevenueresponse !== props.costAndrevenueresponse) {
            this.validateZeroPricedItems();
        }
        if (this.props.invoicedResponse !== props.invoicedResponse) {
            if (!this.props.submitInvoiceError && this.props.invoicedResponse.length > 0) {
                let resp = '';
                this.props.invoicedResponse.forEach((entry: any) => {
                    resp += `${entry.finOpsInvoiceNumber}, sent to ${entry.email ? entry.email : entry.printerName}. `;
                });
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: `Successfully issued invoice ${resp}`
                }, () => {
                    this.props.fetchETSDetails(this.props.match.params.etsId);
                });
            } else {
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: this.props.invoicedResponse ? this.props.invoicedResponse : 'Failed to create an Invoice'
                });
            }
        }
        if (this.props.resendResponse !== props.resendResponse) {
            if (!this.props.isResendError && this.props.resendResponse) {
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: `Successfully resent message to SAP`
                });
            } else if (this.props.isResendError && this.props.resendError) {
                const rawResendError = Array.isArray(this.props.resendError)
                    ? this.props.resendError.join('\n')
                    : this.props.resendError;
                const resendErrorText = rawResendError ? rawResendError.replace(/\|/g, '\n') : '';
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: resendErrorText || 'Failed to resend message to SAP'
                });
            }
        }
        if (props.isFetchDataError !== this.props.isFetchDataError &&
            this.props.isFetchDataError === true && this.props.detailsPendingError) {
            let checkText: string | string[] = props.detailsPendingError;
            if ((Array.isArray(this.props.detailsPendingError) &&
                this.props.detailsPendingError.length === 0) ||
                this.props.detailsPendingError === '') {
                checkText = 'Server Error. Try again later.';
            }
            this.setState({ isSuccess: false, showDialog: true, pendingError: checkText.toString() });
        }
        if (this.props.etsDetails && this.props.etsDetails.rateErrorMessage !== props.etsDetails.rateErrorMessage) {
            const handleError = (error: string): boolean => {
                if (error) {
                    if (isBatchProcessingError(error)) {
                        // Batch-processing errors are surfaced via the dedicated
                        // wait banner; close any stale generic error dialog left
                        // over from a previous non-batch error message.
                        this.setState({ showDialog: false, pendingError: '' });
                    } else {
                        this.setState({ isSuccess: false, showDialog: true, pendingError: error.toString().replace(/\|/g, '\n') });
                    }
                    return true;
                }
                return false;
            };
            const hasError: boolean = this.props.etsDetails && this.props.etsDetails.rateErrorMessage ? handleError(this.props.etsDetails.rateErrorMessage) : false;
            this.setState({
                hasError,
                isSuccess: !hasError
            });
        }
        if (this.props.update && this.props.update !== props.update) {
            if (this.props.isDataFetchErrorCostNRevenue) {
                this.setState({ isSuccess: false, showDialog: true, pendingError: this.props.update });
            } else if (this.props.isFetchDataError) {
                this.setState({ isSuccess: false, showDialog: true, pendingError: this.props.update });
            } else {
                this.setState({ isSuccess: true, showDialog: true, pendingError: this.props.update });
                setTimeout(() => {
                    this.props.fetchETSDetails(this.props.match.params.etsId);
                }, 500);
            }
        }
        if (this.props.etsDetails && this.props.etsDetails.etsFinOpsStatus !== props.etsDetails.etsFinOpsStatus) {
            const status: string[] = this.props.etsDetails && this.props.etsDetails.etsFinOpsStatus ? [this.props.etsDetails.etsFinOpsStatus] : [];
            this.setState({
                status
            });
        }
        if (this.props.ets !== props.ets) {
            if (this.props.ets && this.props.ets.result.length > 0) {
                const newData = this.props.ets.result.map((element: any) => {
                    return { id: element.id, value: element.etsNumber };
                });
                this.setState({ results: newData, showDialog: false });
            } else if (this.props.ets.result.length === 0) {
                this.setState({ showDialog: true, isSuccess: false, pendingError: `No ETS entries found` });
            }
        }
    }

    public validateZeroPricedItems = () => {
        const chargeLines = this.props.costAndrevenueresponse.result[0]?.issoChargeLines || [];
        const zeroPricedItems = chargeLines.filter((item: any) => item.rate === 0 && item.status === chargeStatus.linkedSalesOrder);
        if (zeroPricedItems.length > 0) {
            this.setState({ showZeroPriceError: true });
        }
    };
    public getActualTotal = () => {
        const rateDetailsList = this.props.costAndrevenueresponse.result[0]?.issoChargeLines || [];
        const actualRevenue = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.REVENUE);
        const actualCost = calculateActualTotal(rateDetailsList, CostColumnsData.TYPES.COST);
        this.setState({ actualRevenue, actualCost }) ;
    };
    public checkShowInvoices = () => {
        return Boolean(this.props.etsDetails.etsFinOpsStatus) &&
            (this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.partialInvoiced ||
                this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.partialSettled ||
                this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderCreated ||
                this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderUpdated) &&
            Boolean(this.props.etsDetails.salesOrderNumber) &&
            !Boolean(this.props.etsDetails.rateErrorMessage);
    };
    public checkShowCreate = () => {
        return Boolean(this.props.etsDetails.etsFinOpsStatus) &&
            this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderCreated &&
            !Boolean(this.props.etsDetails.salesOrderNumber) &&
            Boolean(this.props.etsDetails.rateErrorMessage);
    };
    public checkShowUpdate = (isCancel: boolean = false) => {
        const errorRegex = /Sales organization is changed from (BRE|Extra Document Configuration), Kindly cancel and refresh the rates, Existing Sales Org/;
        const isSalesOrgChanged = errorRegex.test(this.state.pendingError);
        const vatPartnerErrorRegex = /vat partner determination has failed/i;
        const isVatPartnerError = vatPartnerErrorRegex.test(this.state.pendingError.toLowerCase());
        const isInvoiceInFinopsCreated = this.props.etsDetails.etsFinOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        let status: boolean = Boolean(this.props.etsDetails.etsFinOpsStatus) &&
            Boolean(this.props.etsDetails.salesOrderNumber) &&
            !isInvoiceInFinopsCreated &&
            this.props.etsDetails.etsFinOpsStatus !== FinOpsStatus.open &&
            !this.props.etsDetails.etsFinOpsStatus.includes('Requested') &&
            this.props.etsDetails.isJobClosed !== 'CLOSED';
        if (isCancel) {
            status = status &&
                !isInvoiceInFinopsCreated &&
                this.props.etsDetails.etsFinOpsStatus !== FinOpsStatus.partialInvoiced &&
                this.props.etsDetails.etsFinOpsStatus !== FinOpsStatus.fullInvoiced &&
                this.props.etsDetails.etsFinOpsStatus !== FinOpsStatus.partialSettled &&
                this.props.etsDetails.etsFinOpsStatus !== FinOpsStatus.fullSettled;
        } else {
            status = status && !isSalesOrgChanged && !isVatPartnerError;
        }
        return status;
    };
    public checkShowResend = () => {
        const isInvoiceInFinopsCreated = this.props.etsDetails.etsFinOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        return Boolean(this.props.etsDetails.etsFinOpsStatus) &&
            !isInvoiceInFinopsCreated &&
            (this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderRequested ||
                this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderUpdateRequested ||
                this.props.etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderCancelRequested);
    };
    public checkShowAthenaRefreshLink = () => {
        const isInvoiceInFinopsCreated = this.props.etsDetails.etsFinOpsStatus.toLocaleLowerCase() === FinOpsStatus.invoiceInFinopsCreatedLowerCase;
        const itemsIncludeAthena = this.props.etsDetails.pricingSource === 2 || this.props.etsDetails.pricingSource === ATHENA;
        // Full Settled still allows a rate refresh; only in-flight (Requested) statuses hide it.
        const isRequested = this.props.etsDetails.etsFinOpsStatus.includes('Requested');
        return itemsIncludeAthena && !isInvoiceInFinopsCreated && !isRequested;
    };
    // Profitability breakdown is shown only when the import MCI charge feature is on
    // and both SCM and MCI division charges are present.
    public getProfitabilityBreakdown = (): IDivisionBreakdown | undefined => {
        const isMciChargeEnabled = isFeatureEnabled(FEATURE_TOGGLES.IMPORT_MCI_CHARGE_ENABLED, this.props.featureToggles);
        const divisions = this.state.divisionBreakdown.rows.map((row) => row.division);
        const hasScmAndMci = divisions.includes('SCM') && divisions.includes('MCI');
        return isMciChargeEnabled && hasScmAndMci ? this.state.divisionBreakdown : undefined;
    };
    public search = (val: string) => {
        this.props.setFilter('CBLNumber', val);
        this.props.applyFilters();
        this.setState({
            results: []
        });
        if (val) {
            this.props.fetchETS(1, 10);
        }
    };
    public checkCancelDialog = () => {
        const resultDataLength = this.props.costAndrevenueresponse.result;
        const getChargeItemSOStatusRev: any[] = resultDataLength.length > 0 && resultDataLength[0].hasOwnProperty('issoChargeLines') && this.props.costAndrevenueresponse.result[0].issoChargeLines.filter((item: any) => {
            return item.status === chargeStatus.linkedFinalInvoice || item.status === chargeStatus.linkedPartialSupplierInvoice || item.status === chargeStatus.linkedSupplierInvoice;
        });
        if (getChargeItemSOStatusRev.length > 0) {
            this.setState({
                confirmDialogCancelSOVisible: true,
                confirmDialogVisible: false
            });
        } else {
            this.setState({
                confirmDialogVisible: true,
                confirmDialogCancelSOVisible: false
            });
        }
    };

    public checkShowCreateSalesOrder = () => {
        const { featureToggles, etsDetails } = this.props;
        const isSalesOrderRequested = etsDetails.etsFinOpsStatus === FinOpsStatus.salesOrderRequested;
        const hasRateErrorMessage = !!etsDetails.rateErrorMessage;

        return isFeatureEnabled(FEATURE_TOGGLES.FINOPS_FINANCE_OUTBOUND_REQUESTS, featureToggles) &&
            isSalesOrderRequested &&
            hasRateErrorMessage;
    };

    public handleSendCreateSalesOrder = async (etsId: string) => {
        const { createSalesOrderImport, nickname } = this.props;
        await createSalesOrderImport(Number(etsId), 3, 1, CATEGORY.ISSO, nickname.employeeId)
            .then((data) => {
                this.setState({
                    showDialog: true,
                    isSuccess: true,
                    pendingError: data
                });
            })
            .catch((error) => {
                this.setState({
                    showDialog: true,
                    isSuccess: false,
                    pendingError: error.response.data ? error.response.data : 'Failed to Create Sales Order'
                });
            });
    };

    public showHideEmptyReturnLocation = () => {
        this.props.fetchHistoryLog(this.props.match.params.etsId.toString(), 'ets');
        const validLog = this.props.response.find((log: IHistoryLogModel) => log.messageType === 'EMPTY_CONTAINER_RETURNED' && log.status === 'Success');
        this.setState({ showEmptyReturnLocation: validLog != null ? true : false });
    }
    public changeTab = (index: number) => {
        this.setState({ activeTab: index - 1 });
        if (index === 2) {
            this.showHideEmptyReturnLocation();
        }
    };
    public render() {
        const isExtraDocumentFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles);
        const enableBlockedType = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_ICP_AUTOMATION, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        const resultDataLength = this.props.costAndrevenueresponse?.result || [];
        const chargeLineLength = resultDataLength.length > 0 && resultDataLength[0]?.hasOwnProperty('issoChargeLines') && this.props.costAndrevenueresponse?.result?.[0]?.issoChargeLines?.length;
        return (
            <React.Fragment>
                <ErrorDialog endpoint={API.ETS.GetDetails} />
                {this.props.etsDetails && this.props.etsDetails.documentNumber && <PageHeader backButton={true}
                    displayConfirm={this.state.disableTab}
                    confirmMessage={this.state.disableTab ? ValidationMessages.CostAndRevenue.Alert_Page_Exit : ''}
                    id="ETS-details">ETS Number: {this.props.etsDetails.documentNumber}</PageHeader>}

                {/* Pending Processing Messages */}
                {this.state.showPendingProcessMessage && this.props.pendingProcessingMessages?.messages?.length > 0 &&
                    <CustomErrorBox
                        messages={this.props.pendingProcessingMessages.messages}
                        onViewAllMessages={() => this.setState({ showPendingProcessMessageModal: true })}
                        onClose={() => this.setState({ showPendingProcessMessage: false })}
                    />
                }

                {isBatchProcessingError(this.props.etsDetails.rateErrorMessage) &&
                    <div className={'padding-bottom-large padding-left-large padding-right-large'}>
                        <BatchProcessingWarning
                            rateErrorMessage={this.props.etsDetails.rateErrorMessage}
                            lastSORequestSentAt={this.props.etsDetails.lastSORequestSentAt}
                        />
                    </div>}
                {this.state.showZeroPriceError && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showZeroPriceError}
                    type="error"
                    message={costAndRevErrorMessage.zeroPriceError}
                    closeMethod={() => this.setState({ showZeroPriceError: false })} /></div>}
                {this.state.showDialog && <div className={'padding-bottom-large padding-left-large padding-right-large'}><InPageDialog
                    showDialog={this.state.showDialog}
                    type={this.state.isSuccess ? 'success' : 'error'}
                    message={this.state.pendingError}
                    closeMethod={() => this.setState({ showDialog: false, isSuccess: false })} /></div>}
                {this.state.confirmDialogVisible && <ConfirmModal
                    title="Cancel Sales Order"
                    visible={this.state.confirmDialogVisible}
                    onConfirm={() => {
                        this.setState({ confirmDialogVisible: false });
                        this.props.updateCharges(this.props.match.params.etsId, 3, 3, CATEGORY.ISSO);
                    }}
                    closeModal={() => { this.setState({ confirmDialogVisible: false }); }}>
                    {ValidationMessages.General.Alert_Cancel_Page}
                </ConfirmModal>}

                {this.state.showPendingProcessMessageModal &&
                    <div className="errorModal">
                        <ModalMain
                            modal={this.state.showPendingProcessMessageModal}
                            title="View All Pending Process Messages"
                            hideMethod={() => { this.setState({ showPendingProcessMessageModal: false }); }}
                            primaryMethod={() => { this.setState({ showPendingProcessMessageModal: false }); }}
                            btnTitle1={'OK'} >
                            <ul className="pending-process-messages-view-all-list">
                                {this.props.pendingProcessingMessages?.messages?.map((message: string, index: number) => (
                                    <li key={index}>{message}</li>
                                ))}
                            </ul>
                        </ModalMain>
                    </div>
                }

                {this.state.confirmDialogCancelSOVisible && <div className="errorModal"><ModalMain
                    modal={this.state.confirmDialogCancelSOVisible}
                    title="Cancel Sales Order"
                    hideMethod={() => { this.setState({ confirmDialogCancelSOVisible: false, pendingError: '' }); }}
                    primaryMethod={() => { this.setState({ confirmDialogCancelSOVisible: false, pendingError: '' }); }}
                    btnTitle1={'OK'} >
                    {ValidationMessages.General.Alert_Cancel_Page_Charge_Status}
                </ModalMain></div>}
                {this.state.confirmDialogUpdateVisible && <div className="errorModal"><ModalMain
                    modal={this.state.confirmDialogUpdateVisible}
                    title="Error Message"
                    hideMethod={() => { this.setState({ confirmDialogUpdateVisible: false, pendingError: '' }); }}
                    primaryMethod={() => { this.setState({ confirmDialogUpdateVisible: false, pendingError: '' }); }}
                    btnTitle1={'OK'} >
                    {ValidationMessages.General.Alert_If_No_Charges}
                </ModalMain></div>}
                <QuickSearch
                    callAPI={this.search}
                    data={this.state.results}
                    isLoading={false}
                />
                <HeaderWrapper
                    firstValueLabel="FinOps Status"
                    firstValue={this.props.etsDetails.etsFinOpsStatus}
                    secondValueLabel="ETD"
                    secondValue={formatDate(this.props.etsDetails.etd)}
                    thirdValueLabel="ETA"
                    thirdValue={formatDate(this.props.etsDetails.eta)}
                    forthValueLabel="Last Update"
                    forthValue={formatDate(this.props.etsDetails.updatedDate)}
                    fifthValue="Created On"
                    fifthValueLabel={formatDate(this.props.etsDetails.createdDate)}
                    statusColor={this.state.hasError ? 'red' : ''}
                    target={0}
                    totals={{
                        firstRow: { label: 'Total Revenue', value: this.state.totalRevenue, actualValue: this.state.actualRevenue },
                        secondRow: { label: 'Total Cost', value: this.state.totalCost, actualValue: this.state.actualCost },
                        lastRow: { label: 'Profitability' },
                        isNftpRoeEnabled: this.state.isNftpRoeEnabled,
                        breakdown: this.getProfitabilityBreakdown()
                    }}
                />
                {this.props.etsDetails && this.props.etsDetails.documents.length > 0 &&
                    <DetailsTopBar
                        number={this.props.etsDetails.documentNumber}
                        shipmentType={`${this.props.etsDetails.equipmentTransport.shipmentTypeAtOrigin}/${this.props.etsDetails.equipmentTransport.shipmentTypeAtDestination}`}
                        placeOfDesconsolidation={this.props.etsDetails.shipment.placeOfDeconsolidationCode}
                        placeOfDeliveryCode={this.props.etsDetails.documents[0] && this.props.etsDetails.documents[0].placeOfDeliveryCode}
                        portOfDischargeCode={this.props.etsDetails.cbls[0] && this.props.etsDetails.cbls[0].finalPortOfDischargeCode}
                        weight={clearFormat(this.props.etsDetails.weight, 3)}
                        quantity={this.props.etsDetails.quantity}
                        package={this.props.etsDetails.packages}
                        tentativeCloseDate={this.props.isNftpBillable ? '' : formatDate(this.props.etsDetails.tentativeCloseDate)}
                        isJobClosed={this.props.isNftpBillable ? '' : this.props.etsDetails.isJobClosed}
                        incoTerm={this.props.etsDetails.incoTerm}
                        reopenDate={this.props.etsDetails.reopenDate}
                        volume={clearFormat(this.props.etsDetails.volume, 3)}
                        soNumber={this.props.isNftpBillable ? '' : this.props.etsDetails.salesOrderNumber}
                        showCreate={this.checkShowCreate() && !this.state.wasSubmitted}
                        showUpdate={this.checkShowUpdate() && !this.state.wasSubmitted}
                        showCancel={this.checkShowUpdate(true)}
                        showResend={this.checkShowResend()}
                        showAthenaRefresh={this.checkShowAthenaRefreshLink()}
                        showCreateSalesOrder={this.checkShowCreateSalesOrder()}
                        onUpdate={(id: any) => {
                            if (chargeLineLength > 0) {
                                this.props.updateCharges(this.props.match.params.etsId, 3, 8, CATEGORY.ISSO);
                                this.setState({ wasSubmitted: true });
                            } else {
                                this.setState({ confirmDialogUpdateVisible: true });
                            }
                        }}
                        onCancel={(id: any) => { this.checkCancelDialog(); }}
                        onCreate={(id: any) => {
                            this.props.updateCharges(this.props.match.params.etsId, 3, 1, CATEGORY.ISSO);
                            this.setState({ wasSubmitted: true });
                        }}
                        onResend={() => {
                            this.props.resendLatestMessage(this.props.match.params.etsId, this.props.etsDetails.etsFinOpsStatus);
                        }}
                        onAthenaRefresh={() => {
                            this.props.refreshAthenaRates(Number(this.props.match.params.etsId), Number(this.props.match.params.etsId), 3, 12);
                        }}
                        onSendCreateSalesOrder={() => { this.handleSendCreateSalesOrder(this.props.match.params.etsId); }}
                        isActionHidden={this.state.isActionHidden}
                        isSAPJobCloseNotification={isFeatureEnabled(FEATURE_TOGGLES.SAPJobCloseNotification, this.props.featureToggles)}
                        isResendMessageFeatureEnabled={isFeatureEnabled(FEATURE_TOGGLES.RESEND_LAST_MESSAGE, this.props.featureToggles)}
                    />}
                <div className="padding-left-large padding-right-large">
                    <TabComponent name="ETS" navLinks={navLinksETS}
                        callbackFc={(e: number) => this.changeTab(e)}
                        activeTab={this.state.activeTab}
                        isDisabled={this.state.disableTab}>
                        {!this.props.isNftpBillableLoading && !this.state.isNftpRoeEnabledLoading && this.props.etsDetails.equipmentTransportShipmentId &&
                            <CostAndRevenue
                                toggleTabs={(b: boolean) => this.setState({ disableTab: b })}
                                fStatus={[this.props.etsDetails.etsFinOpsStatus]}
                                targetId={targetFunctionality.ETS}
                                costAndrevenueresponse={this.props.costAndrevenueresponse}
                                showInvoices={this.checkShowInvoices()}
                                invoicesData={{
                                    consignee: this.props.etsDetails.shipment.consigneeName,
                                    companyCode: this.props.etsDetails.companyCode,
                                    billingCurrency: this.props.etsDetails.salesDocumentCurrency,
                                    salesArea: this.props.etsDetails.salesAreaRev,
                                    fcrNumber: this.props.etsDetails.documentNumber,
                                    fcrId: this.props.etsDetails.equipmentTransportShipmentId,
                                }}
                                partyData={{
                                    country: this.props.etsDetails.companyCode ? this.props.etsDetails.companyCode.slice(0, 2) : this.props.etsDetails.documents[0] && this.props.etsDetails.documents[0].portOfDischargeCode ? this.props.etsDetails.documents[0].portOfDischargeCode.slice(0, 2) : 'CN',
                                    company: this.props.etsDetails.companyCode,
                                    purchase: this.props.etsDetails.salesAreaRev
                                }}
                                getCurrentPageMode={(mode) => this.setState({ isActionHidden: (mode === 'edit' || mode === 'add') ? true : false })}
                                targetType="destination"
                                distributionData={generateDistributionData(this.props.etsDetails)}
                                readOnly={false}
                                splitCols={CostColumnsData.getETSSubCols()}
                                docId={Number(this.props.match.params.etsId)}
                                costAndRevenueId={Number(this.props.match.params.etsId)}
                                navigateTo={(url: string) => this.props.history.push(url)}
                                eventCallback={() => this.setState({ showDialog: false, pendingError: '' })}
                                isJobClosed={this.props.etsDetails.isJobClosed === 'CLOSED' ? true : false}
                                outputCostRev={(cost: any[], revenue: any[]) => {
                                    this.setState({ totalCost: clearFormat(calculateTotalOfField(cost, localCurrency.totalLocalCurrency)) });
                                    this.setState({ totalRevenue: clearFormat(calculateTotalOfField(revenue, localCurrency.totalLocalCurrency)) });
                                    this.setState({ divisionBreakdown: calculateDivisionBreakdown(cost, revenue, localCurrency.totalLocalCurrency) });
                                }}
                                isNftpBillable={this.props.isNftpBillable}
                                isNftpRoeEnabled={this.state.isNftpRoeEnabled}
                                isSourceAthena={this.props.etsDetails.pricingSource === 2 || this.props.etsDetails.pricingSource === ATHENA}
                            />}
                        <ETSDetails
                            organisation={[
                                { label: 'Company Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.companyCode) },
                                { label: 'Sales Area', value: formatValueIfNullOrUndefined(this.props.etsDetails.salesAreaRev) },
                                { label: 'Origin Office', value: formatValueIfNullOrUndefined(this.props.etsDetails.originOffice) },
                                { label: 'Destination Office', value: formatValueIfNullOrUndefined(this.props.etsDetails.destinationOffice) },
                                { label: 'Sales Document Currency', value: formatValueIfNullOrUndefined(this.props.etsDetails.salesDocumentCurrency) },
                                { label: 'Sales Document Type', value: formatValueIfNullOrUndefined(this.props.etsDetails.salesDocumentType) },
                                { label: 'Create Date', value: formatDate(this.props.etsDetails.opsUpdatedDate, 'YYYY-MM-DD HH:mm:ss') }
                            ]}
                            locations={[
                                { label: 'Place of receipt code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfConsolidationCode) },
                                { label: 'Port of loading code', value: this.props.etsDetails.documents[0] && formatValueIfNullOrUndefined(this.props.etsDetails.documents[0].portOfLoadingCode) },
                                { label: 'Port of discharge code', value: this.props.etsDetails.documents[0] && formatValueIfNullOrUndefined(this.props.etsDetails.documents[0].portOfDischargeCode) },
                                { label: 'Place of delivery code', value: this.props.etsDetails.documents[0] && formatValueIfNullOrUndefined(this.props.etsDetails.documents[0].placeOfDeliveryCode) },
                                { label: 'Place of receipt name', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfConsolidationName) },
                                { label: 'Port of loading name', value: this.props.etsDetails.documents[0] && formatValueIfNullOrUndefined(this.props.etsDetails.documents[0].portOfLoadingName) },
                                { label: 'Port of discharge name', value: this.props.etsDetails.documents[0] && formatValueIfNullOrUndefined(this.props.etsDetails.documents[0].portOfDischargeName) },
                                { label: 'Place of delivery name', value: this.props.etsDetails.documents[0] && formatValueIfNullOrUndefined(this.props.etsDetails.documents[0].placeOfDeliveryName) },
                                { label: 'Empty return location code', value: formatValueIfNullOrUndefined(this.state.showEmptyReturnLocation ? this.props.etsDetails.equipmentTransport.emptyContainerReturnedCode : null) },
                                { label: 'Empty return location name', value: formatValueIfNullOrUndefined(this.state.showEmptyReturnLocation ? this.props.etsDetails.equipmentTransport.emptyContainerReturnedName : null) },
                            ]}
                            cargoDetails={[
                                { label: 'Quantity', value: formatValueIfNullOrUndefined(this.props.etsDetails.quantity) },
                                { label: 'Package', value: formatValueIfNullOrUndefined(this.props.etsDetails.packages) },
                                { label: 'Volume (m3)', value: formatValueIfNullOrUndefined(this.props.etsDetails.volume) },
                                { label: 'Weight', value: formatValueIfNullOrUndefined(this.props.etsDetails.weight) },
                                { label: 'Special Cargo Indicator', value: formatValueIfNullOrUndefined(this.props.etsDetails.specialCargoIndicator) },
                            ]}
                            equipmentTransportShipments={[
                                { label: 'Equipment Number', value: formatValueIfNullOrUndefined(this.props.etsDetails.equipmentTransport.equipmentNumber) },
                                { label: 'Seal Number', value: formatValueIfNullOrUndefined(this.props.etsDetails.equipmentTransport.sealNumber1) },
                                { label: 'Substitution Size', value: formatValueIfNullOrUndefined(this.props.etsDetails.equipmentTransport.substitutionSize) },
                                { label: 'Substitution Type', value: formatValueIfNullOrUndefined(this.props.etsDetails.equipmentTransport.substitutionType) },
                                { label: 'Create Date', value: formatValueIfNullOrUndefined(this.props.etsDetails.equipmentTransport.createdDate) },
                                { label: 'Update Date', value: formatValueIfNullOrUndefined(this.props.etsDetails.equipmentTransport.updatedDate) },
                            ]}
                            shipmentDetails={[
                                { label: 'Booking Agent', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.bookingAgent) },
                                { label: 'Cargo Type', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.cargoType) },
                                { label: 'Consignee Business Entity Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.consigneeBusinessEntityCode) },
                                { label: 'Consignee Country Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.consigneeCountryCode) },
                                { label: 'Consignee Name', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.consigneeName) },
                                { label: 'Cosignee FACT Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.cosigneeFACTCode) },
                                { label: 'Document number', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.documentNumber) },
                                { label: 'Place of Consolidation Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfConsolidationCode) },
                                { label: 'Place of Consolidation Name', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfConsolidationName) },
                                { label: 'Place of Deconsolidation Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfDeconsolidationCode) },
                                { label: 'Place of Deconsolidation Name', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfDeconsolidationName) },
                                { label: 'Place of Delivery Code', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfDeliveryCode) },
                                { label: 'Place of Delivery Name', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.placeOfDeliveryName) },
                                { label: 'Prepaid Collect Indicator', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.prepaidCollectIndicator) },
                                { label: 'Reconsolidation Point', value: formatValueIfNullOrUndefined(this.props.etsDetails.shipment.reconsolidationPoint) }
                            ]}
                            link={(url: string) => { this.props.history.push(url); }}
                            booking={{ data: this.props.etsDetails.shipment && this.props.etsDetails.shipment.bookings, cols: shipmentCols, name: 'ETS-booking-' }}
                            cbl={{ data: this.props.etsDetails.cbls, cols: cblColsEts, name: 'ETS-cbls-' }}
                            equipments={{ data: [this.props.etsDetails.equipmentTransport], cols: equipmentColsEts, name: 'ETS-equipments-' }}
                            fcr={{ data: this.props.etsDetails.documents, cols: documentCols(isExtraDocumentFeatureEnabled, isHblConsumptionEnabled), name: 'ETS-billingDocuments-' }}
                            voyages={{ data: this.props.etsDetails.voyages, cols: voyagesCols, name: 'ETS-voyages-' }}
                            customerInvoice={{ data: this.props.etsDetails.billingDocuments, cols: customerInvoiceCols, name: 'ets-customerInvoice-' }}
                            isExtraDocumentFeatureEnabled={isExtraDocumentFeatureEnabled}
                        />
                        {this.state.activeTab === 2 && <Partners isVisible={this.state.activeTab === 2} target={5} targetId={this.props.etsDetails.equipmentTransportShipmentId} />}
                        {this.state.activeTab === 3 &&
                            <HistoryLog
                                shipmentId={this.props.match.params.etsId.toString()}
                                shipmentType={'ets'}
                                isSourceAthena={this.props.etsDetails?.pricingSource === 2 || this.props.etsDetails?.pricingSource === ATHENA}
                                enableBlockedType={enableBlockedType}
                                isNftpBillable={this.props.isNftpBillable}
                            />
                        }
                    </TabComponent>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IStore): IMapStateToProps => ({
    etsDetails: state.ets.etsDetails,
    isLoading: state.ets.isFetchDataLoading,
    isFetchDataError: state.ets.isFetchDataError,
    isDataFetchErrorCostNRevenue: state.costRevenue.isFetchDataError,
    detailsPendingError: state.ets.detailsPendingError,
    materialMasterList: state.materialMaster.materialMasterList,
    update: state.costRevenue.update,
    invoicedResponse: state.invoices.invoicedResponse,
    submitInvoiceError: state.invoices.submitInvoicedError,
    ets: state.ets.ets,
    resendResponse: state.sap.resendResponse,
    resendLoading: state.sap.isResendFetchDataLoading,
    resendError: state.sap.resendPendingError,
    isResendError: state.sap.isResendFetchDataError,
    featureToggles: state.featureToggle.featureToggles,
    costAndrevenueresponse: state.costRevenue.response,
    nickname: state.nickname.userNickName,
    cblId: state.ets.etsDetails.cbls[0]?.cblId,
    pendingProcessingMessages: state.costRevenue.pendingProcessingMessages,
    isNftpBillable: state.ets.nftpBillableResponse?.isNftpBillable,
    isNftpBillableLoading: state.ets.isNftpBillableLoading,
    response: state.historyLog.response,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchETSDetails: (documentId: string) => dispatch(fetchETSDetails(documentId)),
    fetchETS: (pageNumber: number, pageSize: number) => dispatch(fetchETS(pageNumber, pageSize)),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    applyFilters: () => dispatch(applyFiltersAction()),
    updateCharges: (docId: string, docStage: number, rateAction: number, category: 'ESSO' | 'ISSO') => dispatch(updateCharges(Number(docId), docStage, rateAction, category)),
    resendLatestMessage: (docId: string, finOpsStatus: string) => dispatch(resendLatestMessage(docId, 'ETS', finOpsStatus)),
    resetEtsDetails: () => dispatch(resetEtsDetails()),
    fetchCostAndRevenue: (type: number, valueId: any, targetType: string) => dispatch(fetchCostAndRevenue(type, valueId, targetType)),
    refreshAthenaRates: (refId: number, docId: number, docStage: number, rateAction: number) => dispatch(refreshAthenaRates(Number(refId), Number(docId), docStage, rateAction, 'ISSO')),
    createSalesOrderImport: (refId: number, docStage: number, rateAction: number, category: 'ISSO', userId: string) => dispatch(sendCreateSalesOrderImport(refId, docStage, rateAction, category, userId)),
    getPendingProcessMessage: (targetId: number, targetType: 'Export' | 'Import') => dispatch(fetchPendingProcessMessages(targetId, targetType)),
    fetchNftpBillable: (jobId: number) => dispatch(fetchNftpBillable(jobId)),
    fetchHistoryLog: (shipmentId: string, shipmentType: any) => dispatch(fetchHistoryLog(shipmentId, shipmentType)),
    
});

export const _Documents = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_ChargesETSDetails);
export const Ets = withRouter(_Documents);